import { useFlag, useUnleashContext } from '@unleash/proxy-client-react';

import LegacySignup from './legacySignup';
import NewSignup, { SelectWrapper as SelectWrapperComponent } from './newSignup';

export default function Signup() {
  useUnleashContext();

  const useNewSignup = useFlag('orgPickerV2');
  return useNewSignup ? <NewSignup /> : <LegacySignup />;
}

// This didn't change betweem versions
export const SelectWrapper = SelectWrapperComponent;
